module.exports = __webpack_public_path__ + "img/Monte_Kope_12.08c36fc2.jpg";